import { Box, BoxProps, Text } from 'grommet';
import { Right } from 'lib/api';
import { getRightStatusColor } from 'src/utils/styling';
import { RightInfoCard } from './RightInfoCard';
import { RightInfoItem } from './RightInfoItem';
import { RightInfoRow } from './RightInfoRow';

export type BasicInformationProps = {
  background?: BoxProps['background'];
  right: Partial<Right>;
};

export const BasicInformation = ({ background, right }: BasicInformationProps) => {
  return (
    <RightInfoCard title="Basic Information" background={background}>
      <RightInfoRow>
        <RightInfoItem title="Description" value={right.description || 'Not specified'} />
        <RightInfoItem title="Type" value={right.rightType || 'Not specified'} />
        <RightInfoItem
          title="Status"
          value={
            <Box direction="row" align="center" gap="xsmall">
              <Box round="50%" width="10px" height="10px" background={getRightStatusColor(right.status)} />
              <Text truncate color={getRightStatusColor(right.status)} weight={500} size="medium">
                {right.status || 'Not specified'}
              </Text>
            </Box>
          }
        />
        <RightInfoItem
          title="Commercials"
          value={right.commercials?.length ? right.commercials.map((c) => c.title).join(', ') : 'All Commercials'}
        />
      </RightInfoRow>
    </RightInfoCard>
  );
};
